// // src/components/Credit/Credit.jsx

// import React, { useState, useEffect, useContext } from 'react';
// import { userContext } from '../../context/ContextProvider';
// import creditService from '../../services/creditService';
// import CreditTable from './CreditTable';
// import CreditModal from './CreditModal';
// import { showNotification } from '../../utils/notification';
// import ConfirmDialog from "../common/ConfirmDialog";
// import './credit.css';

// /**
//  * Credit Component
//  * Main page component that manages credits
//  * Handles CRUD operations and filtering
//  */
// const Credit = ({ toggleSidebar }) => {
//   // Get user info from your existing context
//   const { role, user } = useContext(userContext);
  
//   // ========== STATE MANAGEMENT ==========
//   const [allCredits, setAllCredits] = useState([]); // Store ALL credits
//   const [filteredCredits, setFilteredCredits] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isSaving, setIsSaving] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedCredit, setSelectedCredit] = useState(null);
//   const [filters, setFilters] = useState({
//     search: '',
//     salesPerson: '',
//     startDate: '',
//     endDate: ''
//   });

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);

//   // Get user role and ID from context
//   const userRole = role;
//   const userId = user?.id || user?.userId;

//   // Debug log
//   console.log('Credit Component - User Info:', { userRole, userId, user, role });

//   const [isConfirmOpen, setIsConfirmOpen] = useState(false);
//   const [creditToDelete, setCreditToDelete] = useState(null);
//   const [isDeleting, setIsDeleting] = useState(false);

//   // Get unique sales persons for dropdown
//   const uniqueSalesPersons = React.useMemo(() => {
//     const salesPersons = allCredits
//       .map(c => {
//         // Handle nested salePerson object
//         const name = c.salePerson?.firstName || c.salesPerson?.firstName || c.sales_person || c.salesPerson;
//         return name;
//       })
//       .filter(Boolean);
//     const unique = [...new Set(salesPersons)];
//     console.log('Unique sales persons:', unique);
//     return unique;
//   }, [allCredits]);

//   const handleDeleteClick = (credit) => {
//     setCreditToDelete(credit);
//     setIsConfirmOpen(true);
//   };

//   // ========== LOAD DATA ON COMPONENT MOUNT ==========
//   useEffect(() => {
//     if (userRole) {
//       loadCredits();
//     }
//   }, [userRole, userId]);

//   // Auto-filter when filters or credits change
//   useEffect(() => {
//     applyFilters();
//     setCurrentPage(1); // Reset to first page when filters change
//   }, [allCredits, filters]);

//   // ========== DATA LOADING ==========
//   const loadCredits = async () => {
//     try {
//       setIsLoading(true);
      
//       if (!userRole) {
//         throw new Error('User role is not available');
//       }
      
//       // Load ALL credits (no pagination on API call)
//       const data = await creditService.getAll(1, 100000, userRole, userId);
//       setAllCredits(data);
//       const roleMessage = userRole === 'supadmin' ? 'all' : 'your';
//       showNotification(`Loaded ${data.length} ${roleMessage} credits`, 'success');
//     } catch (error) {
//       console.error('Error loading credits:', error);
//       showNotification(`Failed to load credits: ${error.message}`, 'error');
//       setAllCredits([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // ========== FILTERING (Client-side) ==========
//   const applyFilters = () => {
//     console.log('Applying filters:', filters);
//     console.log('All credits:', allCredits);
    
//     const safeCredits = Array.isArray(allCredits) ? allCredits : [];
//     let filtered = [...safeCredits];

//     // Filter by sales person
//     if (filters.salesPerson) {
//       filtered = filtered.filter(cred => {
//         const salesPersonName = cred.salePerson?.firstName || cred.salesPerson?.firstName || '';
//         console.log('Checking salesPerson:', salesPersonName, 'against', filters.salesPerson);
//         return salesPersonName === filters.salesPerson;
//       });
//     }

//     // Filter by search (customer name or code)
//     if (filters.search.trim()) {
//       const searchLower = filters.search.toLowerCase();
//       filtered = filtered.filter(cred => {
//         // Handle nested customer object inside credit object
//         const customerName = (cred.credit?.customer?.name || cred.customer?.name || cred.customerName || '').toString().toLowerCase();
//         const code = (cred.code || cred.creditCode || '').toString().toLowerCase();
//         console.log('Searching in:', { customerName, code, searchLower });
//         return customerName.includes(searchLower) || code.includes(searchLower);
//       });
//     }

//     // Filter by start date
//     if (filters.startDate) {
//       filtered = filtered.filter(cred => {
//         if (!cred.createdAt && !cred.date && !cred.Date) return false;
        
//         const dateValue = cred.createdAt || cred.date || cred.Date;
//         const creditDate = new Date(dateValue);
//         const startDate = new Date(filters.startDate);
        
//         // Reset time to start of day for comparison
//         creditDate.setHours(0, 0, 0, 0);
//         startDate.setHours(0, 0, 0, 0);
        
//         console.log('Date comparison (start):', {
//           creditDate: creditDate.toISOString(),
//           startDate: startDate.toISOString(),
//           passes: creditDate >= startDate
//         });
        
//         return creditDate >= startDate;
//       });
//     }

//     // Filter by end date
//     if (filters.endDate) {
//       filtered = filtered.filter(cred => {
//         if (!cred.createdAt && !cred.date && !cred.Date) return false;
        
//         const dateValue = cred.createdAt || cred.date || cred.Date;
//         const creditDate = new Date(dateValue);
//         const endDate = new Date(filters.endDate);
        
//         // Reset time to end of day for comparison
//         creditDate.setHours(0, 0, 0, 0);
//         endDate.setHours(23, 59, 59, 999);
        
//         console.log('Date comparison (end):', {
//           creditDate: creditDate.toISOString(),
//           endDate: endDate.toISOString(),
//           passes: creditDate <= endDate
//         });
        
//         return creditDate <= endDate;
//       });
//     }

//     console.log('Filtered results:', filtered.length, 'from', safeCredits.length);
//     setFilteredCredits(filtered);
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prevFilters => ({
//       ...prevFilters,
//       [name]: value
//     }));
//   };

//   const handleClearFilters = () => {
//     setFilters({
//       search: '',
//       salesPerson: '',
//       startDate: '',
//       endDate: ''
//     });
//     showNotification('Filters cleared', 'info');
//   };

//   // ========== MODAL OPERATIONS ==========
//   const handleAddNew = () => {
//     setSelectedCredit(null);
//     setIsModalOpen(true);
//   };

//   const handleEdit = (credit) => {
//     setSelectedCredit(credit);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedCredit(null);
//   };

//   // ========== CRUD OPERATIONS ==========
//   const handleSave = async (formData) => {
//     try {
//       setIsSaving(true);

//       const payload = {
//         ...formData,
//         amount: parseFloat(formData.amount),
//       };

//       if (selectedCredit) {
//         await creditService.update(selectedCredit.id, payload);
//         showNotification(
//           `Credit "${payload.name}" updated successfully!`,
//           'success'
//         );
//       } else {
//         await creditService.create(payload);
//         showNotification(
//           `New credit "${payload.name}" added successfully!`,
//           'success'
//         );
//       }

//       await loadCredits();
//       handleCloseModal();
//     } catch (error) {
//       console.error('Error saving credit:', error);
//       showNotification(
//         `Failed to save: ${error.message}`,
//         'error'
//       );
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const confirmDelete = async () => {
//     if (!creditToDelete) return;

//     try {
//       setIsDeleting(true);
//       await creditService.delete(creditToDelete.id);
//       showNotification("Credit deleted successfully", "success");
//       await loadCredits();
//     } catch (error) {
//       console.error("Delete failed:", error);
//       showNotification(`Failed to delete: ${error.message}`, "error");
//     } finally {
//       setIsDeleting(false);
//       setIsConfirmOpen(false);
//       setCreditToDelete(null);
//     }
//   };

//   const cancelDelete = () => {
//     setIsConfirmOpen(false);
//     setCreditToDelete(null);
//   };

//   // ========== PAGINATION LOGIC ==========
//   const totalPages = Math.ceil(filteredCredits.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const paginatedCredits = filteredCredits.slice(startIndex, endIndex);

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       setCurrentPage(newPage);
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   if (!userRole) {
//     return (
//       <div className="credit-main-content">
//         <div className="credit-loading">Loading user information...</div>
//       </div>
//     );
//   }

//   // ========== RENDER ==========
//   return (
//     <main className="inventory-main-content">
//       {/* Page Header */}
//       <div className="credit-content-header">
//         <button onClick={toggleSidebar} className="sidebar-toggle-btn" type="button">
//           ☰
//         </button>
//         <h1 className="inventory-content-title">Credit Management</h1>
//         <div className="header-actions">
          
//           {userRole === 'admin' && (
//             <p className="credit-user-info">Viewing your credits</p>
//           )}
//           {userRole === 'supadmin' && (
//             <p className="credit-user-info">Viewing all credits (Super Admin)</p>
//           )}
//         </div>
//         {/* <button 
//           className="credit-btn credit-btn-add" 
//           onClick={handleAddNew}
//         >
//           + Add New Credit
//         </button> */}
//       </div>

//       {/* Filter Controls */}
//       <div className="credit-filter-controls">
//         <div className="credit-filter-group"> 
//           <input
//             type="text"
//             name="search"
//             placeholder="Search by customer name or code..."
//             value={filters.search}
//             onChange={handleFilterChange}
//             className="credit-custom-input credit-search-input"
//             style={{ flex: 1, minWidth: '250px' }}
//           />

//           <select
//             name="salesPerson"
//             value={filters.salesPerson}
//             onChange={handleFilterChange}
//             className="credit-custom-select"
//           >
//             <option value="">All Sales Persons</option>
//             {uniqueSalesPersons.sort().map(person => (
//               <option key={person} value={person}>{person}</option>
//             ))}
//           </select>

//           <input
//             type="date"
//             name="startDate"
//             value={filters.startDate}
//             onChange={handleFilterChange}
//             className="credit-custom-input credit-date-input"
//             placeholder="Start Date"
//           />

//           <input
//             type="date"
//             name="endDate"
//             value={filters.endDate}
//             onChange={handleFilterChange}
//             className="credit-custom-input credit-date-input"
//             placeholder="End Date"
//           />

//           <button 
//             className="inventory-btn inventory-btn-clear" 
//             onClick={handleClearFilters}
//           >
//             Clear Filters
//           </button>
//         </div>

//         {/* Filter Summary */}
//         <div style={{ marginTop: '12px', fontSize: '14px', color: '#666' }}>
//           Showing <strong>{filteredCredits.length > 0 ? startIndex + 1 : 0}-{Math.min(endIndex, filteredCredits.length)}</strong> of{' '}
//           <strong>{filteredCredits.length}</strong> filtered results
//           {filteredCredits.length !== allCredits.length && (
//             <span> (from <strong>{allCredits.length}</strong> total)</span>
//           )}
//         </div>
//       </div>

//       {/* Data Table */}
//       <CreditTable
//         credits={paginatedCredits}
//         onEdit={handleEdit}
//         onDelete={handleDeleteClick}
//         isLoading={isLoading}
//       />

//       {/* Pagination Controls */}
//       <div className="pagination-controls">
//         <button 
//           className="btn-page" 
//           disabled={currentPage === 1} 
//           onClick={handlePreviousPage}
//         >
//           Previous
//         </button>
        
//         <div className="page-numbers">
//           {currentPage > 2 && (
//             <>
//               <button className="btn-page-num" onClick={() => handlePageChange(1)}>1</button>
//               {currentPage > 3 && <span className="page-ellipsis">...</span>}
//             </>
//           )}
          
//           {currentPage > 1 && (
//             <button 
//               className="btn-page-num" 
//               onClick={() => handlePageChange(currentPage - 1)}
//             >
//               {currentPage - 1}
//             </button>
//           )}
          
//           <button className="btn-page-num active">{currentPage}</button>
          
//           {currentPage < totalPages && (
//             <button 
//               className="btn-page-num" 
//               onClick={() => handlePageChange(currentPage + 1)}
//             >
//               {currentPage + 1}
//             </button>
//           )}
          
//           {currentPage < totalPages - 1 && (
//             <>
//               {currentPage < totalPages - 2 && <span className="page-ellipsis">...</span>}
//               <button className="btn-page-num" onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
//             </>
//           )}
//         </div>

//         <span className="page-info">Page {currentPage} of {totalPages || 1}</span>
        
//         <button 
//           className="btn-page" 
//           disabled={currentPage === totalPages || totalPages === 0}
//           onClick={handleNextPage}
//         >
//           Next
//         </button>
//       </div>

//       {/* Add/Edit Modal */}
//       <CreditModal
//         isOpen={isModalOpen}
//         onClose={handleCloseModal}
//         onSave={handleSave}
//         credit={selectedCredit}
//         isSaving={isSaving}
//       />

//       {/* Delete Confirmation Dialog */}
//       <ConfirmDialog
//         isOpen={isConfirmOpen}
//         title="Delete Credit"
//         message={`Are you sure you want to delete "${creditToDelete?.name}"?`}
//         onConfirm={confirmDelete}
//         onCancel={cancelDelete}
//         isProcessing={isDeleting}
//       />
//     </main>
//   );
// };

// export default Credit;

// src/components/Credit/Credit.jsx

import React, { useState, useEffect, useContext } from 'react';
import { userContext } from '../../context/ContextProvider';
import creditService from '../../services/creditService';
import CreditTable from './CreditTable';
import CreditModal from './CreditModal';
import { showNotification } from '../../utils/notification';
import ConfirmDialog from "../common/ConfirmDialog";
import './credit.css';

/**
 * Credit Component
 * Main page component that manages credits
 * Handles CRUD operations and filtering
 */
const Credit = ({ toggleSidebar }) => {
  // Get user info from your existing context
  const { role, user } = useContext(userContext);
  
  // ========== STATE MANAGEMENT ==========
  const [allCredits, setAllCredits] = useState([]); // Store ALL credits
  const [filteredCredits, setFilteredCredits] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCredit, setSelectedCredit] = useState(null);
  const [filters, setFilters] = useState({
    search: '',
    salesPerson: '',
    startDate: '',
    endDate: ''
  });

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  // Get user role and ID from context
  const userRole = role;
  const userId = user?.id || user?.userId;

  // Debug log
  console.log('Credit Component - User Info:', { userRole, userId, user, role });

  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [creditToDelete, setCreditToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  // Get unique sales persons for dropdown
  const uniqueSalesPersons = React.useMemo(() => {
    const salesPersons = allCredits
      .map(c => {
        // Handle nested salePerson object
        const name = c.salePerson?.firstName || c.salesPerson?.firstName || c.sales_person || c.salesPerson;
        return name;
      })
      .filter(Boolean);
    const unique = [...new Set(salesPersons)];
    console.log('Unique sales persons:', unique);
    return unique;
  }, [allCredits]);

  const handleDeleteClick = (credit) => {
    setCreditToDelete(credit);
    setIsConfirmOpen(true);
  };

  // ========== LOAD DATA ON COMPONENT MOUNT ==========
  useEffect(() => {
    if (userRole) {
      loadCredits();
    }
  }, [userRole, userId]);

  // Auto-filter when filters or credits change
  useEffect(() => {
    applyFilters();
    setCurrentPage(1); // Reset to first page when filters change
  }, [allCredits, filters]);

  // ========== DATA LOADING ==========
  const loadCredits = async () => {
    try {
      setIsLoading(true);
      
      if (!userRole) {
        throw new Error('User role is not available');
      }
      
      // Load ALL credits (no pagination on API call)
      const data = await creditService.getAll(1, 100000, userRole, userId);
      setAllCredits(data);
      const roleMessage = userRole === 'supadmin' ? 'all' : 'your';
      showNotification(`Loaded ${data.length} ${roleMessage} credits`, 'success');
    } catch (error) {
      console.error('Error loading credits:', error);
      showNotification(`Failed to load credits: ${error.message}`, 'error');
      setAllCredits([]);
    } finally {
      setIsLoading(false);
    }
  };

  // ========== FILTERING (Client-side) ==========
  const applyFilters = () => {
    console.log('Applying filters:', filters);
    console.log('All credits:', allCredits);
    
    const safeCredits = Array.isArray(allCredits) ? allCredits : [];
    let filtered = [...safeCredits];

    // Filter by sales person
    if (filters.salesPerson) {
      filtered = filtered.filter(cred => {
        const salesPersonName = cred.salePerson?.firstName || cred.salesPerson?.firstName || '';
        console.log('Checking salesPerson:', salesPersonName, 'against', filters.salesPerson);
        return salesPersonName === filters.salesPerson;
      });
    }

    // Filter by search (customer name or code)
    if (filters.search.trim()) {
      const searchLower = filters.search.toLowerCase();
      filtered = filtered.filter(cred => {
        // Handle nested customer object inside credit object
        const customerName = (cred.credit?.customer?.name || cred.customer?.name || cred.customerName || '').toString().toLowerCase();
        const code = (cred.code || cred.creditCode || '').toString().toLowerCase();
        console.log('Searching in:', { customerName, code, searchLower });
        return customerName.includes(searchLower) || code.includes(searchLower);
      });
    }

    // Filter by start date
    if (filters.startDate) {
      filtered = filtered.filter(cred => {
        if (!cred.createdAt && !cred.date && !cred.Date) return false;
        
        const dateValue = cred.createdAt || cred.date || cred.Date;
        const creditDate = new Date(dateValue);
        const startDate = new Date(filters.startDate);
        
        // Reset time to start of day for comparison
        creditDate.setHours(0, 0, 0, 0);
        startDate.setHours(0, 0, 0, 0);
        
        console.log('Date comparison (start):', {
          creditDate: creditDate.toISOString(),
          startDate: startDate.toISOString(),
          passes: creditDate >= startDate
        });
        
        return creditDate >= startDate;
      });
    }

    // Filter by end date
    if (filters.endDate) {
      filtered = filtered.filter(cred => {
        if (!cred.createdAt && !cred.date && !cred.Date) return false;
        
        const dateValue = cred.createdAt || cred.date || cred.Date;
        const creditDate = new Date(dateValue);
        const endDate = new Date(filters.endDate);
        
        // Reset time to end of day for comparison
        creditDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);
        
        console.log('Date comparison (end):', {
          creditDate: creditDate.toISOString(),
          endDate: endDate.toISOString(),
          passes: creditDate <= endDate
        });
        
        return creditDate <= endDate;
      });
    }

    console.log('Filtered results:', filtered.length, 'from', safeCredits.length);
    setFilteredCredits(filtered);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value
    }));
  };

  const handleClearFilters = () => {
    setFilters({
      search: '',
      salesPerson: '',
      startDate: '',
      endDate: ''
    });
    showNotification('Filters cleared', 'info');
  };

  // ========== MODAL OPERATIONS ==========
  const handleAddNew = () => {
    setSelectedCredit(null);
    setIsModalOpen(true);
  };

  const handleEdit = (credit) => {
    setSelectedCredit(credit);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCredit(null);
  };

  // ========== CRUD OPERATIONS ==========
  const handleSave = async (formData) => {
    try {
      setIsSaving(true);

      const payload = {
        ...formData,
        amount: parseFloat(formData.amount),
      };

      if (selectedCredit) {
        await creditService.update(selectedCredit.id, payload);
        showNotification(
          `Credit "${payload.name}" updated successfully!`,
          'success'
        );
      } else {
        await creditService.create(payload);
        showNotification(
          `New credit "${payload.name}" added successfully!`,
          'success'
        );
      }

      await loadCredits();
      handleCloseModal();
    } catch (error) {
      console.error('Error saving credit:', error);
      showNotification(
        `Failed to save: ${error.message}`,
        'error'
      );
    } finally {
      setIsSaving(false);
    }
  };

  const confirmDelete = async () => {
    if (!creditToDelete) return;

    try {
      setIsDeleting(true);
      await creditService.delete(creditToDelete.id);
      showNotification("Credit deleted successfully", "success");
      await loadCredits();
    } catch (error) {
      console.error("Delete failed:", error);
      showNotification(`Failed to delete: ${error.message}`, "error");
    } finally {
      setIsDeleting(false);
      setIsConfirmOpen(false);
      setCreditToDelete(null);
    }
  };

  const cancelDelete = () => {
    setIsConfirmOpen(false);
    setCreditToDelete(null);
  };

  // ========== PAGINATION LOGIC ==========
  const totalPages = Math.ceil(filteredCredits.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedCredits = filteredCredits.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  if (!userRole) {
    return (
      <div className="credit-main-content">
        <div className="credit-loading">Loading user information...</div>
      </div>
    );
  }

  // ========== RENDER ==========
  return (
    <main className="inventory-main-content">
      {/* Page Header */}
      <div className="credit-content-header">
        <button onClick={toggleSidebar} className="sidebar-toggle-btn" type="button">
          ☰
        </button>
        <h1 className="inventory-content-title">Credit Management</h1>
        <div className="header-actions">
          
          {userRole === 'admin' && (
            <p className="credit-user-info">Viewing your credits</p>
          )}
          {userRole === 'supadmin' && (
            <p className="credit-user-info">Viewing all credits (Super Admin)</p>
          )}
        </div>
        {/* <button 
          className="credit-btn credit-btn-add" 
          onClick={handleAddNew}
        >
          + Add New Credit
        </button> */}
      </div>

      {/* Filter Controls */}
      <div className="credit-filter-controls">
        <div className="credit-filter-group"> 
          <input
            type="text"
            name="search"
            placeholder="Search by customer name or code..."
            value={filters.search}
            onChange={handleFilterChange}
            className="credit-custom-input credit-search-input"
            style={{ flex: 1, minWidth: '250px' }}
          />

          <select
            name="salesPerson"
            value={filters.salesPerson}
            onChange={handleFilterChange}
            className="credit-custom-select"
          >
            <option value="">All Sales Persons</option>
            {uniqueSalesPersons.sort().map(person => (
              <option key={person} value={person}>{person}</option>
            ))}
          </select>

          <input
            type="date"
            name="startDate"
            value={filters.startDate}
            onChange={handleFilterChange}
            className="credit-custom-input credit-date-input"
            placeholder="Start Date"
          />

          <input
            type="date"
            name="endDate"
            value={filters.endDate}
            onChange={handleFilterChange}
            className="credit-custom-input credit-date-input"
            placeholder="End Date"
          />

          <button 
            className="inventory-btn inventory-btn-clear" 
            onClick={handleClearFilters}
          >
            Clear Filters
          </button>
        </div>

        {/* Filter Summary */}
        <div style={{ marginTop: '12px', fontSize: '14px', color: '#666' }}>
          Showing <strong>{filteredCredits.length > 0 ? startIndex + 1 : 0}-{Math.min(endIndex, filteredCredits.length)}</strong> of{' '}
          <strong>{filteredCredits.length}</strong> filtered results
          {filteredCredits.length !== allCredits.length && (
            <span> (from <strong>{allCredits.length}</strong> total)</span>
          )}
        </div>
      </div>

      {/* Data Table */}
      <CreditTable
        credits={paginatedCredits}
        allFilteredData={filteredCredits}
        onEdit={handleEdit}
        onDelete={handleDeleteClick}
        isLoading={isLoading}
      />

      {/* Pagination Controls */}
      <div className="pagination-controls">
        <button 
          className="btn-page" 
          disabled={currentPage === 1} 
          onClick={handlePreviousPage}
        >
          Previous
        </button>
        
        <div className="page-numbers">
          {currentPage > 2 && (
            <>
              <button className="btn-page-num" onClick={() => handlePageChange(1)}>1</button>
              {currentPage > 3 && <span className="page-ellipsis">...</span>}
            </>
          )}
          
          {currentPage > 1 && (
            <button 
              className="btn-page-num" 
              onClick={() => handlePageChange(currentPage - 1)}
            >
              {currentPage - 1}
            </button>
          )}
          
          <button className="btn-page-num active">{currentPage}</button>
          
          {currentPage < totalPages && (
            <button 
              className="btn-page-num" 
              onClick={() => handlePageChange(currentPage + 1)}
            >
              {currentPage + 1}
            </button>
          )}
          
          {currentPage < totalPages - 1 && (
            <>
              {currentPage < totalPages - 2 && <span className="page-ellipsis">...</span>}
              <button className="btn-page-num" onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
            </>
          )}
        </div>

        <span className="page-info">Page {currentPage} of {totalPages || 1}</span>
        
        <button 
          className="btn-page" 
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={handleNextPage}
        >
          Next
        </button>
      </div>

      {/* Add/Edit Modal */}
      <CreditModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSave={handleSave}
        credit={selectedCredit}
        isSaving={isSaving}
      />

      {/* Delete Confirmation Dialog */}
      <ConfirmDialog
        isOpen={isConfirmOpen}
        title="Delete Credit"
        message={`Are you sure you want to delete "${creditToDelete?.name}"?`}
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
        isProcessing={isDeleting}
      />
    </main>
  );
};

export default Credit;
